import { ResidentStatus } from '@lmc/ts-common'

export type ResidentLike = {
  status: string
  name: { first: string; last: string }
  carers?: string[]
  keyworkers?: string[]
  assignAll?: boolean
}

const activeOnly = (residents: ResidentLike[] = []) =>
  residents.filter((res) => res.status === ResidentStatus.active)

const fullName = (res: ResidentLike) => `${res.name.first} ${res.name.last}`

export const deriveAssignedResidentNames = (
  residents: ResidentLike[] = [],
  userId: string
): string[] =>
  activeOnly(residents)
    .filter((res) => res.assignAll || res.carers?.includes(userId))
    .map(fullName)

export const deriveKeyworkerResidentNames = (
  residents: ResidentLike[] = [],
  userId: string
): string[] =>
  activeOnly(residents)
    .filter((res) => res.keyworkers?.includes(userId))
    .map(fullName)
